import { Controller } from "@hotwired/stimulus"

// Кнопка «Проверить связь» в разделе настроек: подбирает способ обрамления
// сообщения и показывает сырой ответ либо диагностику по каждой попытке.
export default class extends Controller {
  static values = { url: String }
  static targets = ["button", "output"]

  async test() {
    this.buttonTarget.disabled = true
    this.outputTarget.classList.remove("d-none")
    this.outputTarget.innerHTML = "<div class='text-muted'>Проверяем…</div>"

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Accept": "application/json"
        }
      })
      const data = await response.json()
      this.outputTarget.innerHTML = data.success ? this.successHtml(data) : this.failureHtml(data)
      if (data.success) window.location.reload()
    } catch (error) {
      this.outputTarget.innerHTML = `<div class="alert alert-danger mb-0">Ошибка запроса: ${this.escape(error.message)}</div>`
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  successHtml(data) {
    return `
      <div class="alert alert-success mb-2">Связь есть. Способ обрамления: ${this.escape(data.framing_label)}</div>
      <pre class="bg-light p-2 small mb-0">${this.escape(data.raw_response || "")}</pre>
    `
  }

  failureHtml(data) {
    const rows = (data.attempts || []).map((attempt) => this.attemptHtml(attempt)).join("")
    return `
      <div class="alert alert-danger mb-2">Связь не установлена ни одним способом обрамления.</div>
      <ul class="small">${rows}</ul>
      ${this.disclosure("Отправленный запрос", data.request_xml)}
    `
  }

  // Ответ сервера показывается рядом с ошибкой попытки: без него не отличить
  // молчание сервера от ответа, который не удалось разобрать.
  attemptHtml(attempt) {
    return `
      <li>
        <code>${this.escape(attempt.framing || "—")}</code>: ${this.escape(attempt.error || "")}
        ${this.disclosure("Ответ сервера", attempt.raw_response)}
      </li>
    `
  }

  disclosure(summary, content) {
    if (!content) return ""

    return `
      <details class="mt-1">
        <summary class="small text-muted">${this.escape(summary)}</summary>
        <pre class="bg-light p-2 small mb-0">${this.escape(content)}</pre>
      </details>
    `
  }

  escape(value) {
    const div = document.createElement("div")
    div.textContent = value
    return div.innerHTML
  }
}
